import { createSelector } from '@reduxjs/toolkit';
import { getAuthToken, getUserData } from './user';
import { getDeployment } from './config';
import { GlobalState } from '../rootReducer';
import api from '@/redux/api/consignment';

/* Action Types */
export const SUBMIT_CONSIGNMENT_FAIL = 'la/user/consignment/FAIL';
export const SUBMIT_CONSIGNMENT_REQUEST = 'la/user/consignment/REQUEST';
export const SUBMIT_CONSIGNMENT_SUCCESS = 'la/user/consignment/SUCCESS';

// reducer
export const DEFAULT_STATE = {
    error: false,
    submitted: false,
    success: false,
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case SUBMIT_CONSIGNMENT_REQUEST:
            return {
                ...state,
                error: false,
                submitted: true,
                success: false,
            };

        case SUBMIT_CONSIGNMENT_SUCCESS:
            return {
                ...state,
                submitted: false,
                success: true,
            };

        case SUBMIT_CONSIGNMENT_FAIL:
            return {
                ...state,
                error: true,
                errorMessage: action.payload,
                submitted: false,
                success: false,
            };

        default:
            return state;
    }
}

const submitConsignmentSelector = (state: GlobalState) => state.consignment;

export const getSubmitConsignment = createSelector(submitConsignmentSelector, (consignment) => consignment);

/* ACTION CREATORS */
export const submitConsignment = (form: any, file: any) => async (dispatch: Function, getState: Function) => {
    try {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        const userData = getUserData(state);
        dispatch({
            type: SUBMIT_CONSIGNMENT_REQUEST,
        });
        await api.postConsignment({ authToken, deployment, file, form, userData });
        dispatch({
            payload: form,
            type: SUBMIT_CONSIGNMENT_SUCCESS,
        });
    } catch (error) {
        dispatch({
            error: true,
            payload: error,
            type: SUBMIT_CONSIGNMENT_FAIL,
        });
    }
};
